/**
 * Custom Sticky Add to Cart — Baser Theme
 * File: assets/custom-sticky-atc.js
 *
 * El add-to-cart y la apertura del drawer los gestiona el
 * custom element <xo-cart-add> de Baser.
 * Este script solo se encarga de:
 *   1. Mostrar/ocultar la barra al hacer scroll.
 *   2. Sincronizar variante (xo-variant-id, precio, imagen) cuando
 *      el usuario cambia de variante en la ficha de producto.
 *   3. Gestionar el estado visual de agotado.
 */

(function () {
  'use strict';

  const SCROLL_THRESHOLD = 700; // px — cuándo aparece la barra

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const bar = document.getElementById('custom-sticky-atc');
    if (!bar) return;

    const cartAddEl      = bar.querySelector('xo-cart-add');
    const btn            = bar.querySelector('.csatc__btn');
    const btnLabel       = bar.querySelector('.csatc__btn-label');
    const priceEl        = bar.querySelector('.csatc__price');
    const comparePriceEl = bar.querySelector('.csatc__compare-price');
    const imgEl          = bar.querySelector('.csatc__image-wrap img');

    // ── 1. Scroll visibility ──────────────────────────────────────────────────

    let ticking = false;

function onScroll() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(function () {
    const scrollY    = window.scrollY || window.pageYOffset;
    const nearFooter = isNearFooter();
    const shouldShow = scrollY > SCROLL_THRESHOLD && !nearFooter;

    if (shouldShow) {
      bar.style.display = 'block';
      // Pequeño delay para que el display:block se pinte antes de la transición
      requestAnimationFrame(function () {
        bar.classList.add('is-visible');
      });
    } else {
      bar.classList.remove('is-visible');
      // Ocultar tras la transición (280ms)
      setTimeout(function () {
        if (!bar.classList.contains('is-visible')) {
          bar.style.display = 'none';
        }
      }, 300);
    }

    ticking = false;
  });
}

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ── 2. Variant sync ───────────────────────────────────────────────────────
    // Escuchamos los eventos que Baser / xo-product puede disparar.
    // Añadimos todos los nombres conocidos para máxima compatibilidad.

    [
      'variant:change',
      'variantChange',
      'product:variant-changed',
      'xo:variant:change',
      'xo:product:variant',
    ].forEach(function (evName) {
      document.addEventListener(evName, handleVariantChange);
    });

    // Fallback: observar el input/select name="id" del formulario principal
    const productForm = locateProductForm();
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"], select[name="id"]');
      if (variantInput) {
        variantInput.addEventListener('change', function () {
          syncVariantId(variantInput.value);
        });
      }
    }

    // ── Helpers ───────────────────────────────────────────────────────────────

    function isNearFooter() {
      const footer = document.querySelector('footer, #footer, .footer');
      if (!footer) return false;
      return footer.getBoundingClientRect().top < window.innerHeight + 80;
    }

    function locateProductForm() {
      return (
        document.querySelector('form[action="/cart/add"]') ||
        document.querySelector('.product-form form') ||
        document.querySelector('#product-form') ||
        document.querySelector('[data-product-form]')
      );
    }

    /**
     * Actualiza el atributo xo-variant-id del custom element <xo-cart-add>.
     * Baser espera el valor como array JSON: "[variantId]"
     */
    function syncVariantId(id) {
      if (!id || !cartAddEl) return;
      cartAddEl.setAttribute('xo-variant-id', '[' + id + ']');
      bar.dataset.variantId = String(id);
    }

    /**
     * Procesa el evento de cambio de variante.
     * Los distintos temas/plugins usan estructuras de detail diferentes;
     * intentamos leer la variante de las formas más comunes.
     */
    function handleVariantChange(event) {
      const detail  = event.detail;
      if (!detail) return;

      // Normalizar: la variante puede estar en detail.variant o ser el propio detail
      const variant = (detail && typeof detail === 'object' && detail.id)
        ? detail
        : (detail.variant && typeof detail.variant === 'object' ? detail.variant : null);

      if (!variant) return;

      // a) Actualizar xo-variant-id para que xo-cart-add envíe la variante correcta
      if (variant.id) syncVariantId(variant.id);

      // b) Precio actual
      if (variant.price !== undefined && priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      // c) Precio comparado
      if (comparePriceEl) {
        const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        comparePriceEl.textContent  = showCompare ? formatMoney(variant.compare_at_price) : '';
        comparePriceEl.style.display = showCompare ? '' : 'none';
      }

      // d) Imagen de variante
      if (imgEl && variant.featured_image && variant.featured_image.src) {
        const src = ('https:' + variant.featured_image.src)
          .replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_120x120$1');
        imgEl.src = src;
      }

      // e) Estado agotado
      updateAvailability(variant.available);
    }

    /**
     * Muestra u oculta el estado "Agotado" en el botón.
     */
    function updateAvailability(available) {
      if (!btn || !btnLabel) return;

      if (available === false) {
        btn.disabled = true;
        btn.classList.add('is-soldout');
        btn.setAttribute('aria-disabled', 'true');
        btnLabel.textContent = 'Agotado';
        bar.dataset.available = 'false';
      } else {
        btn.disabled = false;
        btn.classList.remove('is-soldout');
        btn.removeAttribute('aria-disabled');
        if (btnLabel.textContent === 'Agotado') {
          btnLabel.textContent = 'Añadir al carrito +';
        }
        bar.dataset.available = 'true';
      }
    }

    /**
     * Formatea centavos a moneda local usando Shopify.formatMoney si existe,
     * o Intl.NumberFormat como fallback.
     */
    function formatMoney(cents) {
      if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }
  }
})();